function initializeNavigation() {
	const SUB_NAV_CONTAINER_CLASS = '.sub-nav__portal';
	const SUB_NAV_CONTAINER_ACTIVE_CLASS = '.active';
	const SUB_NAV_LINK_CLASS = '.sub-nav__link';
	const SUB_NAV_EXPAND_BTN_CLASS = '.sub-nav__expand-button';
	const SUB_NAV_MENU_CLASS = '.sub-nav__menu';
	const HEADER_CLASS = 'header';
	const HEADER_STUCK_CLASS = 'sticky-header--stuck';
	const NAV_OBS_OPTIONS = { rootMargin: '0px', threshold: 1.0 };
	const STICKY_HEADER_ANCHOR_CLASS = 'sticky-header-anchor';
	const navStickyObserverCallback = (entries, observer) => {
		const header = document.querySelector(`.${HEADER_CLASS}`);
		if (!header) {
			return;
		}
		entries.forEach((entry) => {
			const isStuck = !entry.isIntersecting;
			header.classList.toggle(HEADER_STUCK_CLASS, isStuck);
		});
	};
	const stickyHeaderObserver = new IntersectionObserver(navStickyObserverCallback, NAV_OBS_OPTIONS);
	const isExpanded = (portal) => portal.matches(SUB_NAV_CONTAINER_ACTIVE_CLASS);
	const setState = (portal, state) => {
		const isCurrentlyExpanded = isExpanded(portal);
		const isToggling = state === null;
		const shouldExpand = isToggling ? !isCurrentlyExpanded : state;
		portal.querySelector(SUB_NAV_EXPAND_BTN_CLASS).ariaExpanded = shouldExpand;
		portal.classList.toggle('active', shouldExpand);
		if (shouldExpand) {
			portal.querySelector(SUB_NAV_MENU_CLASS).focus();
		}
	};
	const setExpanded = (targetPortal, state, portals) => {
		for (const portal of portals) {
			const isTarget = targetPortal === portal;
			setState(portal, isTarget ? state : false);
		}
	};
	const navPortals = document.querySelectorAll(SUB_NAV_CONTAINER_CLASS);
	navPortals.forEach((portal) => {
		portal.addEventListener('mouseenter', () => setExpanded(portal, true, navPortals));
		portal.addEventListener('mouseleave', () => setExpanded(portal, false, navPortals));
		const expandButton = portal.querySelector(SUB_NAV_EXPAND_BTN_CLASS);
		expandButton.addEventListener('click', (e) => {
			e.preventDefault();
			setExpanded(portal, null, navPortals);
		});
	});
	const stickyHeaderAnchor = document.querySelector(`.${STICKY_HEADER_ANCHOR_CLASS}`);
	if (stickyHeaderAnchor) {
		stickyHeaderObserver.observe(stickyHeaderAnchor);
	}
}
document.addEventListener('DOMContentLoaded', initializeNavigation);
